import { cx } from "../ui/cx";

/** The landing page's red LIVE badge, with a ping on the dot. */
export function LiveBadge({ className }: { className?: string }) {
  return (
    <span className={cx("inline-flex items-center gap-1.5 rounded-md bg-accent px-2 py-0.5 font-mono text-xs font-bold tracking-wider text-white", className)}>
      <span aria-hidden="true" className="relative flex size-1.5">
        <span className="absolute inset-0 rounded-full bg-white motion-safe:animate-ping-dot" />
        <span className="relative size-1.5 rounded-full bg-white" />
      </span>
      LIVE
    </span>
  );
}

/** Bouncing level bars: decoration that says "audio is going out". Static when motion is reduced. */
export function Equalizer({ bars = 16, className }: { bars?: number; className?: string }) {
  return (
    <span aria-hidden="true" className={cx("flex h-8 items-end justify-between gap-[3px]", className)}>
      {Array.from({ length: bars }, (_, i) => (
        <span
          key={i}
          className="h-full w-1 origin-bottom rounded-full bg-white/50 motion-safe:animate-eq"
          style={{ animationDelay: `${(i * -0.13) % 1.4}s`, transform: `scaleY(${0.3 + ((i * 37) % 70) / 100})` }}
        />
      ))}
    </span>
  );
}
